import { useEffect, useState } from "react";

import { FragmentDefiner } from "../../../GlobalHooks/useReadFragment";
import { PropComponentMode } from "../PropertyInterfaces";

export const FRAGMENT_FACILITIES = new FragmentDefiner(
	"Property",
	`
    facilities {
      name
      group
    }
    project {
      facilities
    }
`
);

export interface FacilitiesProps {
	mode?: PropComponentMode;
	facilities: [{ name: string }] | [string];
	loading?: boolean;
	isEspecial?: Boolean;
}

const parseProjectFacilities = facilities => {
	return facilities.map(f => {
		if (typeof f == "string") return { name: f };
		else if (f.name) return f;
		else return "";
	});
};

export function useFacilities(facilities) {
	const [facilitiesList, setFacilities] = useState([]);

	useEffect(() => {
		setFacilities(parseProjectFacilities(facilities));
	}, [facilities]);

	return { facilitiesList };
}
